import React, { useCallback, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { cmApi } from "./cmApi";

export default function RegisterDetail() {
  const { slug } = useParams();
  const [registers, setRegisters] = useState([]);
  const [entries, setEntries] = useState([]);
  const [draft, setDraft] = useState({});
  const [error, setError] = useState("");

  const register = registers.find((r) => r.slug === slug);
  const columns = register ? register.columns || [] : [];

  const load = useCallback(async () => {
    const [regs, ents] = await Promise.all([
      cmApi.listRegisters(),
      cmApi.listEntries(slug),
    ]);
    setRegisters(regs);
    setEntries(ents);
  }, [slug]);

  useEffect(() => {
    load().catch(() => setError("Could not load register."));
  }, [load]);

  const addEntry = async () => {
    await cmApi.addEntry(slug, draft);
    setDraft({});
    load();
  };

  return (
    <div className="p-6" data-testid="cm-register-detail">
      <Link to="/compliance/mvp/registers" className="text-sm text-indigo-600">
        ← Registers
      </Link>
      <h1 className="mt-2 text-xl font-semibold text-slate-800">
        {register ? register.title : slug}
      </h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}

      <table className="mt-6 w-full border-collapse text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-left text-slate-500">
            {columns.map((c) => (
              <th key={c} className="py-2 pr-4 font-medium">{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {entries.map((e) => (
            <tr key={e._id} className="border-b border-slate-100" data-testid="cm-entry-row">
              {columns.map((c) => (
                <td key={c} className="py-2 pr-4 text-slate-700">{e.data[c] ?? ""}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {entries.length === 0 && <p className="mt-3 text-sm text-slate-500">No entries yet.</p>}

      {columns.length > 0 && (
        <div className="mt-6 rounded border border-slate-200 p-4">
          <h2 className="text-sm font-semibold text-slate-700">Add entry</h2>
          <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
            {columns.map((c) => (
              <input
                key={c}
                placeholder={c}
                value={draft[c] || ""}
                onChange={(e) => setDraft({ ...draft, [c]: e.target.value })}
                className="rounded border border-slate-300 px-2 py-1 text-sm"
                data-testid={`cm-entry-input-${c}`}
              />
            ))}
          </div>
          <button
            onClick={addEntry}
            className="mt-3 rounded bg-indigo-600 px-3 py-1 text-sm text-white"
            data-testid="cm-add-entry"
          >
            Add entry
          </button>
        </div>
      )}
    </div>
  );
}
